// src/api/axiosInstance.js
import axios from "axios";

// 1. Axios Instance banaya Base URL ke sath
const API = axios.create({
 // baseURL: "http://localhost:5000", // 👈 Development me localhost rahega, cPanel par upload karte waqt "https://api.crjoin.online" kar dena
 baseURL: "https://crjoin.online/backend",
  headers: {
    "Content-Type": "application/json",
  },
});

// 2. 🔥 REQUEST INTERCEPTOR (Most Important)
// Iska kaam hai har API request se pehle localStorage se token uthana aur use automatically headers me attach kar dena
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Browser se token nikala
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Headers me 'Bearer <token>' set kiya
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default API;